// All local storage keys must be versioned so they can easily be upgraded.
export enum LocalStorageKey {
  Betslip = 'Betslip_v0.0.1',
  AppSettings = 'AppSettings_v0.0.3',
}
